import { useCallback, useContext } from 'react'
import { Transition } from 'history'
import { useBlocker } from './useBlocker'
import { Context } from './context'

export const usePrompt = (ignorePromptFn?: (tx: Transition) => boolean, when = true) => {
  const showPrompt = useContext(Context)

  const blocker = useCallback(
    async (tx: Transition) => {
      if (ignorePromptFn?.(tx)) {
        tx.retry()
        return
      }

      try {
        await showPrompt()
        tx.retry()
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
      } catch {}
    },
    [showPrompt, ignorePromptFn]
  )

  return useBlocker(blocker, when)
}
